import { RootState } from "index";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";

const Navdata = () => {
  const user = useSelector((state: RootState) => state.Login.user);

  const filterMenuTree = (items: any[]): any[] =>
    items
      .map((item) => {
        const key = item?.permissionKey ?? item?.permissionkey;

        if (key && !user?.permissions?.includes(`${key}.Read`)) {
          return null;
        }

        if (item?.subItems) {
          const children = filterMenuTree(item?.subItems);
          if (!children.length && key) return null;
          return { ...item, subItems: children };
        }

        return item;
      })
      .filter(Boolean);

  const [isDashboard, setIsDashboard] = useState(false);
  const [isCustomer, setIsCustomer] = useState(false);
  const [isMaster, setIsMaster] = useState(false);
  const [isItemMaster, setIsItemMaster] = useState(false);
  const [isInward, setIsInward] = useState(false);
  const [isStore, setIsStore] = useState(false);
  const [isDiscount, setIsDiscount] = useState(false);
  const [isProduct, setIsProduct] = useState(false);
  const [isMakingCharges, setIsMakingCharges] = useState(false);
  const [isDirectory, setIsDirectory] = useState(false);
  const [isUser, setIsUser] = useState(false);
  const [isRewardOpen, setIsRewardOpen] = useState(false);
  const [isLedger, setIsLedger] = useState(false)
  const [isAuthentication, setIsAuthentication] = useState(false);
  const [isAuth, setIsAuth] = useState(false);
  const [isSalesInventory, setIsSalesInventory] = useState(false);
  const [iscurrentState, setIscurrentState] = useState("Dashboard");

  function updateIconSidebar(e: any) {
    if (e && e.target && e.target.getAttribute("sub-items")) {
      const ul: any = document.getElementById("two-column-menu");
      const iconItems: any = ul.querySelectorAll(".nav-icon.active");
      let activeIconItems = [...iconItems];
      activeIconItems.forEach((item) => {
        item.classList.remove("active");
        var id: any = item.getAttribute("sub-items");
        var menusId = document.getElementById(id);
        if (menusId) {
          (menusId.parentElement as HTMLElement).classList.remove("show");
        }
      });
      e.target.classList.add("active");
    }
  }
  useEffect(() => {
    document.body.classList.remove("twocolumn-panel");

    if (iscurrentState !== "Dashboard") {
      setIsDashboard(false);
    }
    if (iscurrentState !== "Customer") {
      setIsDashboard(false);
    }
    if (iscurrentState !== "Master") {
      setIsDashboard(false);
    }
    if (iscurrentState !== "Store") {
      setIsDashboard(false);
    }
    if (iscurrentState !== "ItemMaster") {
      setIsDashboard(false);
    }
    if (iscurrentState !== "Discount") {
      setIsDashboard(false);
    }
    if (iscurrentState !== "Product") {
      setIsDashboard(false);
    }
    if (iscurrentState !== "Making-Charges") {
      setIsDashboard(false);
    }
    if (iscurrentState !== "Directore") {
      setIsDashboard(false);
    }
    if (iscurrentState !== "User") {
      setIsDashboard(false);
    }
    if (iscurrentState !== "Authentication") {
      setIsAuthentication(false);
    }
    if (iscurrentState !== "Auth") {
      setIsAuth(false);
    }
    if (iscurrentState !== "SalesInventory") {
      setIsSalesInventory(false);
    }
    if (iscurrentState !== "ledger") {
      setIsLedger(false);
    }
  }, [
    iscurrentState,
    isDashboard,
    isCustomer,
    isMaster,
    isStore,
    isItemMaster,
    isDiscount,
    isProduct,
    isMakingCharges,
    isDirectory,
    isUser,
    isAuth,
    isAuthentication,
    isSalesInventory,
    isLedger,
  ]);

  const menuItems: any = [
    // Dashbord
    {
      id: "dashboard",
      label: "Dashboard",
      icon: "bx bx-grid-alt",
      link: "/dashboard",
      permissionKey: "Dashboard"
    },
    // Module 2: Customer
    {
      id: "customer",
      label: "Customer",
      link: "/#",
      parentId: "customer",
      icon: "bx bx-user",
      isChildItem: true,
      permissionKey: "Customer",
      click: function (e: any) {
        e.preventDefault();
        setIsCustomer(!isCustomer);
      },
      stateVariables: isCustomer,
      subItems: [
        {
          id: "customer",
          label: "Customer",
          link: "/customer",
          parentId: "customer",
          permissionKey: "Customer",
        },
      ],
    },
    // Module 3: Master
    {
      id: "master-main",
      label: "Master",
      icon: "bx bx-collection",
      link: "/#",
      permissionKey: "Master",
      click: function (e: any) {
        e.preventDefault();
        setIsDashboard(!isMaster);
        setIscurrentState("Dashboard");
        updateIconSidebar(e);
      },
      stateVariables: isDashboard,
      subItems: [
        {
          id: "karat",
          label: "Karat Master",
          link: "/karat-master",
          parentId: "rate-master",
          permissionKey: "Karat",
        },
        {
          id: "metal",
          label: "Metal Master",
          link: "/metal-master",
          parentId: "rate-master",
          permissionKey: "Metal",
        },
        {
          id: "gold-rate",
          label: "Gold Rate",
          link: "/gold-rate",
          parentId: "rate-master",
          permissionKey: "GoldRateMaster",
        },
        {
          id: "material-type",
          label: "Material Type",
          link: "/material-type",
          parentId: "rate-master",
          permissionKey: "MaterialType",
        },
        {
          id: "walkInSource",
          label: "Walk In Source",
          link: "/walk-in-source",
          parentId: "rate-master",
          permissionKey: "WalkInSource",
        },
        // {
        //   id: "rejectReason",
        //   label: "Reject Reason",
        //   link: "/reject-reason",
        //   parentId: "rate-master",
        //   permissionKey: "RejectReason",
        // },
        // {
        //   id: "paymenttype",
        //   label: "Payment Type",
        //   link: "/payment-type",
        //   parentId: "rate-master",
        //   permissionKey: "PaymentType",
        // },
        {
          id: "repair-work",
          label: "Repair Work",
          link: "/repair-work",
          parentId: "rate-master",
          permissionKey: "RepairWork",
        },
        // {
        //   id: "old-gold-rate",
        //   label: "Old Gold Rate",
        //   link: "/old-gold-rate",
        //   parentId: "rate-master",
        //   permissionKey: "OldGoldRate",
        // },
        {
          id: "deduction-master",
          label: "Deduction Master",
          link: "/deduction",
          parentId: "rate-master",
          permissionKey: "ReturnDeduction",
        },
        // {
        //   id: "ktConversion",
        //   label: "Kt Conversion Master",
        //   link: "/kt-conversion-master",
        //   parentId: "rate-master",
        //   permissionKey: "Karat",
        // },
      ],
    },
    // Module 4: Store
    {
      id: "store",
      label: "Store",
      link: "/#",
      parentId: "store",
      icon: "bx bx-store",
      permissionKey: "Store",
      isChildItem: true,
      click: function (e: any) {
        e.preventDefault();
        setIsStore(!isStore);
      },
      stateVariables: isStore,
      subItems: [
        {
          id: "store",
          label: "Store",
          link: "/store",
          parentId: "store",
          permissionKey: "Store",
        },

        {
          id: "SalesPerson",
          label: "Sales Person",
          link: "/sales-person",
          parentId: "store",
          permissionKey: "SalesPerson",
        },
        {
          id: "BillType",
          label: "Bill Type",
          link: "/bill-type",
          parentId: "store",
          permissionKey: "BillType",
        },
        {
          id: "BillSetting",
          label: "Bill Setting",
          link: "/bill-setting",
          parentId: "store",
          permissionKey: "BillSetting",
        },
      ],
    },
    // Module 5: Discount
    {
      id: "discount",
      label: "Discount",
      link: "/#",
      icon: "bx bx-purchase-tag-alt",
      parentId: "discount",
      permissionKey: "DiscountMaster",
      isChildItem: true,
      click: function (e: any) {
        e.preventDefault();
        setIsDiscount(!isDiscount);
      },
      stateVariables: isDiscount,
      subItems: [

        {
          id: "Discount",
          label: "Consumer Offer",
          link: "/discount",
          parentId: "discount",
          permissionKey: "ConsumerOffers",
        },
        {
          id: "DiscountVoucher",
          label: "Discount Voucher",
          link: "/discount-voucher",
          parentId: "discount",
          permissionKey: "DiscountVoucher",
        },
      ],
    },
    // Module 6: Product
    {
      id: "product",
      label: "Product",
      link: "/#",
      parentId: "product",
      icon: "bx bx-package",
      permissionKey: "ProductMaster",
      isChildItem: true,
      click: function (e: any) {
        e.preventDefault();
        setIsProduct(!isProduct);
      },
      stateVariables: isProduct,
      subItems: [
        {
          id: "category",
          label: "Category",
          link: "/category",
          parentId: "product",
          permissionKey: "Category",
        },
        {
          id: "subcategory",
          label: "SubCategory",
          link: "/subcategory",
          parentId: "product",
          permissionKey: "SubCategory",
        },
        {
          id: "collection",
          label: "Collection",
          link: "/collection",
          parentId: "product",
          permissionKey: "Collection",
        },
        // {
        //   id: "company",
        //   label: "Company",
        //   link: "/company",
        //   parentId: "product",
        //   permissionKey: "Company",
        // },
        // {
        //   id: "diamondShape",
        //   label: "Diamond Shape",
        //   link: "/diamond-shape",
        //   parentId: "product",
        //   permissionKey: "DiamondShape",
        // },
        {
          id: "metalColor",
          label: "Metal Color",
          link: "/metal-color",
          parentId: "product",
          permissionKey: "MetalColor",
        },
        {
          id: "style",
          label: "Style Master",
          link: "/style-master",
          parentId: "product",
          permissionKey: "StyleMaster",
        },
        {
          id: "product_Header",
          label: "Product Header",
          link: "/product-header",
          parentId: "product",
          permissionKey: "ProductHeader",
        },
        {
          id: "product_Details",
          label: "Product Details",
          link: "/product-details",
          parentId: "product",
          permissionKey: "ProductDetails",
        },
      ],
    },


    // Module 7: Making Charges
    {
      id: "makingCharges",
      label: "Making Charges",
      link: "/#",
      icon: "bx bx-money",
      parentId: "makingCharges",
      permissionkey: "MakingMaster",
      isChildItem: true,
      click: function (e: any) {
        e.preventDefault();
        setIsMakingCharges(!isMakingCharges);
      },
      stateVariables: isMakingCharges,
      subItems: [
        {
          id: "goldMakingCharges",
          label: "Gold Making Charges",
          link: "/gold-making-charges",
          parentId: "makingCharges",
          permissionKey: "GoldMakingCharges",
        },
        {
          id: "diamondMakingCharges",
          label: "Diamond Making Charges",
          link: "/diamond-making-charges",
          parentId: "makingCharges",
          permissionKey: "DiamondMakingCharges",
        },
      ],
    },

    //Module :transaction

    {
      id: "Transaction",
      label: "Transaction",
      link: "/#",
      icon: "bx bx-rupee",
      parentId: "Transaction",
      permissionkey: "Transaction",
      isChildItem: true,
      click: function (e: any) {
        e.preventDefault();
        setIsMakingCharges(!isMakingCharges);
      },
      stateVariables: isMakingCharges,
      subItems: [
        {
          id: "salesEntryList",
          label: "Sales Entry List",
          link: "/sales-entry-list",
          parentId: "Transaction",
          permissionKey: "SalesEntryList",
        },
        {
          id: 'returnOrderList',
          label: 'Return Order List',
          link: '/return-order-list',
          parentId: 'Transaction',
          permissionKey: 'ReturnSalesOrder',
        },

      ],
    },

    // Module 8: Directory
    {
      id: "directory-master",
      label: "Directory",
      link: "/#",
      icon: "bx bx-folder",
      parentId: "directory-master",
      permissionkey: "Directory",
      isChildItem: true,
      click: function (e: any) {
        e.preventDefault();
        setIsDirectory(!isDirectory);
      },
      stateVariables: isDirectory,
      subItems: [
        {
          id: "country",
          label: "Country",
          link: "/country-directory",
          parentId: "directory-master",
          permissionKey: "Country",
        },
        {
          id: "State",
          label: "State",
          link: "/state-directory",
          parentId: "directory-master",
          permissionKey: "StateProvince",
        },
        {
          id: "city",
          label: "City",
          link: "/city-directory",
          parentId: "directory-master",
          permissionKey: "City",
        },
      ],
    },
    // Module 9: User
    {
      id: "User",
      label: "User ",
      link: "/#",
      icon: "bx bx-user",
      parentId: "master-main",
      permissionkey: "User",
      isChildItem: true,
      click: function (e: any) {
        e.preventDefault();
        setIsMaster(!isMaster);
      },
      stateVariables: isMaster,
      subItems: [
        {
          id: "user-master",
          label: "User Master",
          link: "/user-master",
          parentId: "User",
          permissionKey: "User",
        },
        {
          id: "role-master",
          label: "Role Master",
          link: "/role-master",
          parentId: "User",
          permissionKey: "UserRole",
        },
      ],
    },
    {
      id: "reward",
      label: "Reward ",
      permissionKey: "RewardMaster",
      link: "/#",
      icon: 'bx bx-gift',
      parentId: "master-main",
      isChildItem: true,
      click: function (e: any) {
        e.preventDefault();
        setIsRewardOpen(!isRewardOpen);
      },
      stateVariables: isRewardOpen,
      subItems: [
        {
          id: "RewardEarning",
          label: "Earning-Reward",
          link: "/earning-rewards",
          parentId: "reward",
          permissionKey: "EarningSetting",
        },
        {
          id: "RewardRedemption",
          label: "Redemption-Reward",
          link: "/redemption-rewards",
          parentId: "reward",
          permissionKey: "RedemptionSetting",
        },
      ],
    },

    //interstore
    {
      id: "interstore",
      label: "Inter Store Orders",
      icon: "bx bxs-truck",
      link: "/interstore",
      permissionKey: "InterStore",
      parentId: "master-main",
    },


    //ledger
    {
      id: "Ledger",
      label: "Ledger",
      permissionKey: "EarningSetting",
      link: "/#",
      icon: 'bx bx-book',
      parentId: "master-main",
      permissionkey: "Ledger",
      isChildItem: true,
      click: function (e: any) {
        e.preventDefault();
        setIsRewardOpen(!isRewardOpen);
      },
      stateVariables: isRewardOpen,
      subItems: [
        {
          id: "Ladger",
          label: "Store Ledger",
          link: "/storeLedger",
          parentId: "reward",
          permissionKey: "StoreLedger",
        },
        {
          id: "Ledger",
          label: "Customer Ledger",
          link: "/customerLedger",
          parentId: "reward",
          permissionKey: "Ledger",
        },
      ],
    },

    // Item Master 
    {
      id: "itemMaster",
      label: "Item Master",
      link: "/#",
      parentId: "itemMaster",
      icon: "bx bx-layer",
      permissionKey: "Master",
      isChildItem: true,
      click: function (e: any) {
        e.preventDefault();
        setIsItemMaster(!isItemMaster);
      },
      stateVariables: isItemMaster,
      subItems: [

        {
          id: "purchaseOrder",
          label: "Purchase Order",
          parentId: "purchaseOrder",
          icon: "bx bx-cart",
          permissionKey: "Master",
          subItems: [
            {
              id: "poProcess",
              label: "PO Process",
              link: "/po-process",
              parentId: "purchaseOrder",
              icon: "bx bx-clipboard",
              permissionKey: "Master",
            },
            {
              id: "poOrders",
              label: "PO Orders",
              link: "/po-orders",
              parentId: "purchaseOrder",
              icon: "bx bx-clipboard",
              permissionKey: "Master",
            },
          ]
        },
        {
          id: "stock",
          label: "Stock",
          parentId: "itemMaster",
          icon: "bx bx-cube",
          permissionKey: "Master",
          subItems: [
            {
              id: "poInward",
              label: "PO Inward",
              link: "/po-inward",
              parentId: "itemMaster",
              icon: "bx bx-clipboard",
              permissionKey: "Master",
            },
            {
              id: "poInventory",
              label: "PO Inventory",
              link: "/po-inventory",
              parentId: "itemMaster",
              icon: "bx bx-clipboard",
              permissionKey: "Master",
            },
            {
              id: "poOrders",
              label: "Assigned Products",
              link: "/assign-products",
              parentId: "purchaseOrder",
              icon: "bx bx-clipboard",
              permissionKey: "Master",
            },
            {
              id: "poInventory",
              label: "Rejected Products",
              link: "/rejected-products",
              parentId: "itemMaster",
              icon: "bx bx-clipboard",
              permissionKey: "Master",
            },
          ],
        },
        {
          id: "itemMasterPage",
          label: "Item Master",
          link: "/item-master",
          parentId: "itemMaster",
          icon: "bx bx-package",
          permissionKey: "Master",
        },
        {
          id: "vendorMasterPage",
          label: "Vendor Master",
          link: "/vendor-master",
          permissionKey: "Master",
          parentId: "itemMaster",
        },
      ]
    },
    {
      id: "dashboard",
      label: "Return Policy",
      icon: "bx bx-file",
      link: "/return-policy",
      permissionKey: 'StorePolicy'
    },
  ];

  const filteredMenuItems = filterMenuTree(menuItems);

  return <React.Fragment>{filteredMenuItems}</React.Fragment>;
};

export default Navdata;
